"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as m } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: a, size: c = 24 } = _param, s = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = n(), o = a !== null && a !== void 0 ? a : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: r } = m();
    return r.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, s), {
        children: /* @__PURE__ */ e("path", {
            fill: o,
            d: "M6.287 4.694c0-1.207-.96-2.194-2.143-2.194C2.96 2.5 2 3.482 2 4.694s.96 2.193 2.144 2.193c1.183 0 2.143-.986 2.143-2.193m14.995.365H7.713A.72.72 0 0 1 7 4.329c0-.402.32-.73.713-.73h13.57c.392 0 .712.328.712.73a.72.72 0 0 1-.713.73M22 12c0-.402-.32-.73-.713-.73H7.713A.72.72 0 0 0 7 12c0 .402.32.73.713.73h13.57A.723.723 0 0 0 22 12m-.713 6.946c.393 0 .713.327.713.73s-.32.73-.718.73H7.713a.72.72 0 0 1-.713-.73c0-.402.32-.73.713-.73zM6.287 12c0-1.207-.96-2.194-2.143-2.194C2.96 9.806 2 10.79 2 12s.96 2.194 2.144 2.194c1.183 0 2.143-.987 2.143-2.194m-2.139.73a.72.72 0 0 1-.713-.73c0-.402.32-.73.713-.73s.713.328.713.73-.32.73-.713.73m2.139 6.576c0-1.207-.96-2.193-2.143-2.193-1.184 0-2.144.982-2.144 2.193S2.96 21.5 4.144 21.5c1.183 0 2.143-.982 2.143-2.194m-2.139.73a.72.72 0 0 1-.713-.73c0-.402.32-.73.713-.73s.713.328.713.73-.32.73-.713.73m0-14.613a.72.72 0 0 1-.713-.73c0-.402.32-.729.713-.729a.72.72 0 0 1 .713.73c0 .402-.32.73-.713.73"
        })
    })) : r.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, s), {
        children: /* @__PURE__ */ e("path", {
            fill: o,
            d: "M6.287 4.694c0-1.207-.96-2.194-2.143-2.194C2.96 2.5 2 3.482 2 4.694s.96 2.193 2.144 2.193c1.183 0 2.143-.986 2.143-2.193m14.995.365H7.713A.72.72 0 0 1 7 4.329c0-.402.32-.73.713-.73h13.57c.392 0 .712.328.712.73a.72.72 0 0 1-.713.73M22 12c0-.402-.32-.73-.713-.73H7.713A.72.72 0 0 0 7 12c0 .402.32.73.713.73h13.57A.723.723 0 0 0 22 12m-.713 6.946c.393 0 .713.327.713.73s-.32.73-.718.73H7.713a.72.72 0 0 1-.713-.73c0-.402.32-.73.713-.73zM6.287 12c0-1.207-.96-2.194-2.143-2.194C2.96 9.806 2 10.79 2 12s.96 2.194 2.144 2.194c1.183 0 2.143-.987 2.143-2.194m-2.139.73a.72.72 0 0 1-.713-.73c0-.402.32-.73.713-.73s.713.328.713.73-.32.73-.713.73m2.139 6.576c0-1.207-.96-2.193-2.143-2.193-1.184 0-2.144.982-2.144 2.193S2.96 21.5 4.144 21.5c1.183 0 2.143-.982 2.143-2.194m-2.139.73a.72.72 0 0 1-.713-.73c0-.402.32-.73.713-.73s.713.328.713.73-.32.73-.713.73m0-14.613a.72.72 0 0 1-.713-.73c0-.402.32-.729.713-.729a.72.72 0 0 1 .713.73c0 .402-.32.73-.713.73"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, s), {
        children: /* @__PURE__ */ e("path", {
            fill: o,
            d: "M4.46 6.957c0-.613-.515-1.112-1.15-1.112-.64 0-1.155.499-1.155 1.112s.515 1.11 1.154 1.112c.636 0 1.151-.498 1.151-1.112m.98-.003c0 .41.36.74.8.74h14.803c.443 0 .798-.33.798-.74 0-.409-.358-.74-.798-.74H6.239c-.443 0-.798.331-.798.74m15.603 4.303c.44 0 .798.33.798.74 0 .408-.355.739-.798.739H6.239c-.44 0-.798-.33-.798-.74 0-.409.355-.74.798-.74zm-16.583.74c0-.614-.515-1.113-1.15-1.113-.64 0-1.155.499-1.155 1.112s.515 1.112 1.154 1.112c.636 0 1.151-.498 1.151-1.112m16.583 4.302c.44 0 .798.33.798.74 0 .406-.355.739-.798.739H6.239c-.44 0-.798-.333-.798-.74s.355-.74.798-.74zm-16.583.74c0-.614-.515-1.113-1.15-1.113-.64 0-1.155.496-1.155 1.112 0 .611.515 1.11 1.154 1.112.636 0 1.151-.501 1.151-1.112"
        })
    }));
}, v = h;
export { v as default };
